module.exports = __webpack_public_path__ + "img/rotationCrop-256--tiny.43e29544.png";